<div *ngIf="errorText$ | async as errorText" @slide [@.disabled]="!animate">
	{{ errorText }}
</div>
